import { pushDataLayer } from '../index'
import { PageViewLayer } from '@component/dataLayer'

export default function PageViewDataLayer() {

  return (
    <PageViewLayer data={{
      'vertical': 'suburb',
      'vertical_type': 'suburb',
      'page_type': 'detail',
      'event': 'page_view'
    }}></PageViewLayer>
  )
}

export const trackDataLayer = {
  click() {
    pushDataLayer({
      'event': 'analytics_track',
      'event_journey': 'Suburb Track',
      'event_interaction': 'Suburb page',
      'event_type': 'Track this suburb bottom'
    })
  },

  manage() {
    pushDataLayer({
      'event': 'analytics_track',
      'event_journey': 'Suburb Track',
      'event_interaction': 'Suburb page',
      'event_type': 'Manage tracked suburbs'
    })
  },

  show() {
    pushDataLayer({
      'event': 'analytics_track',
      'event_journey': 'Suburb Track',
      'event_interaction': 'Modal',
      'event_type': 'Enter email'
    })
  },

  registered() {
    pushDataLayer({
      'event': 'analytics_track',
      'event_journey': 'Suburb Track',
      'event_interaction': 'Modal',
      'event_type': 'Sign in to track this suburb'
    })
  },

  notRegistered() {
    pushDataLayer({
      'event': 'analytics_track',
      'event_journey': 'Suburb Track',
      'event_interaction': 'Modal',
      'event_type': 'Create password'
    })
  },

  signin() {
    pushDataLayer({
      'event': 'analytics_track',
      'event_journey': 'Suburb Track',
      'event_interaction': 'Modal',
      'event_type': 'Sign in to track this suburb'
    })
  },

  success() {
    pushDataLayer({
      'event': 'analytics_track',
      'event_journey': 'Suburb Track',
      'event_interaction': 'Modal',
      'event_type': 'Suburb track success'
    })
  }
}